import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Events } from 'ionic-angular';

import { UrAddPage } from '../ur-add/ur-add'
import { ZapisPage } from '../zapis/zapis'
import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-ur-list',
  templateUrl: 'ur-list.html',
})
export class UrListPage {

  item: any;
  items: any;
  error: string;
  count: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http,
    public events: Events
  ) {

    this.loadData();

  }

  loadData() {

    this.item = this.navParams.get('item');

    //console.log(this.item);

    if (!this.navParams.get('item')) {

      let loadingPopup = this.loadingCtrl.create({
        content: ''
      });

      loadingPopup.present();
      //console.log(this.params.apiURL + '?act=list-all&id_user=' + this.params.id_user);
      let that = this;
      this.http.get(this.params.apiURL + '?act=list-all&id_user=' + this.params.id_user)
        .timeout(20000)
        .map(res => res.json())
        .subscribe(
          data => {
            //console.log(data);
            this.count = data.count;
            this.items = data.items;
            this.error = "0";

            if (that.navParams.get('id_show')) {
              this.items.forEach(function(item, i) {
                if (item.id==that.navParams.get('id_show')) that.item = item;
              });                
            }              

            loadingPopup.dismiss();

          },

          err => {
            loadingPopup.dismiss();
            this.error = "1";
          }

        );

    } else {
      console.log(this.params.apiURL + '?act=set-viewed&id_user=' + this.params.id_user+'&id='+this.item.id+'&type='+this.item.type);
      this.http.get(this.params.apiURL + '?act=set-viewed&id_user=' + this.params.id_user+'&id='+this.item.id+'&type='+this.item.type)
        .timeout(20000)
        .map(res => res.json())
        .subscribe(
          data => {

          },

          err => {
          }

        );  
        let that = this;
        setTimeout(function () {
          that.http.get(that.params.apiURL + '?act=list-ans-reqs-not-viewed&id_user='+ + that.params.id_user)
          .timeout(20000)
          .map(res => res.json())
          .subscribe(
            data => {
              that.params.new_ans = data.count;
              that.events.publish('chmenu');
            },
            err => {
            }
          );  
        }, 500);


    }
  }

  itemShow(item) {
    // That's right, we're pushing to ourselves!
    if (item.answered != '') {
      this.navCtrl.push(UrListPage, {
        item: item
      });
    }
  }

  setLiked(val) {
    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });

    loadingPopup.present();
    //console.log(this.params.apiURL + '?act=set-like&id=' + this.item.id + '&type=' + this.item.type + '&val=' + val);
    this.http.get(this.params.apiURL + '?act=set-like&id=' + this.item.id + '&type=' + this.item.type + '&val=' + val)
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          if (val == 'yes') this.item.liked = 'Да';
          if (val == 'no') this.item.liked = 'Нет';


          this.error = "0";

          loadingPopup.dismiss();


        },

        err => {
          loadingPopup.dismiss();
          this.error = "1";
        }

      );
  }

  doRefresh(refresher) {
    //Потянули вниз для обновления данных
    this.loadData();

    setTimeout(() => {
      refresher.complete();
    }, 2000);
  }
  
  addQ() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.setRoot(UrAddPage);
  }

  openCons() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(UrAddPage);
  }

  openZapis() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(ZapisPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UrListPage');
  }

  ionViewWillEnter() {
    this.params.stat('list-quest');    
  }     

}



// WEBPACK FOOTER //
// ./src/pages/ur-list/ur-list.ts